<script setup lang="ts">
import { computed } from 'vue';
import { RouterLink, useRoute } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

const route = useRoute();
const authStore = useAuthStore();

const navItems = computed(() => [
  { name: 'Dashboard', path: '/dashboard', icon: 'home' },
  ...(authStore.hasInsights ? [{ name: 'Insights', path: '/insights', icon: 'insights' }] : []),
  { name: 'Settings', path: '/settings', icon: 'settings' },
  ...(authStore.isAdmin ? [{ name: 'Admin', path: '/admin', icon: 'admin' }] : []),
]);

const isActive = (path: string) => route.path === path;

const initial = computed(() => (authStore.user?.email?.[0] || 'U').toUpperCase());

function logout() {
  authStore.logout();
}
</script>

<template>
  <header class="bg-white dark:bg-gray-800 shadow-sm">
    <div class="container mx-auto px-4">
      <div class="flex items-center justify-between h-16">
        <RouterLink to="/dashboard" class="flex items-center space-x-2">
          <div class="w-8 h-8 bg-primary-600 rounded-lg flex items-center justify-center">
            <span class="text-white font-bold text-lg">A</span>
          </div>
          <span class="text-xl font-semibold text-gray-900 dark:text-white">Aletheias</span>
        </RouterLink>

        <nav class="hidden md:flex items-center space-x-1">
          <RouterLink
            v-for="item in navItems"
            :key="item.path"
            :to="item.path"
            class="px-4 py-2 rounded-lg text-sm font-medium transition-colors"
            :class="isActive(item.path)
              ? 'bg-primary-50 text-primary-700 dark:bg-primary-900 dark:text-primary-300'
              : 'text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700'"
          >
            {{ item.name }}
          </RouterLink>
        </nav>

        <div class="flex items-center space-x-3">
          <span class="text-sm text-gray-600 dark:text-gray-300 hidden sm:inline">
            {{ authStore.user?.email || 'User' }}
          </span>
          <div class="w-8 h-8 bg-gray-200 dark:bg-gray-600 rounded-full flex items-center justify-center">
            <span class="text-gray-600 dark:text-gray-300 text-sm font-medium">{{ initial }}</span>
          </div>
          <button
            type="button"
            @click="logout"
            class="text-sm text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
            title="Sign out"
          >
            Sign out
          </button>
        </div>
      </div>
    </div>
  </header>
</template>
